import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useVehicleLicensePlate = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [fetchedVehicleLicenseData, setFetchedVehicleLicenseData] = useState<any[]>([]);

  const onSearchVehicleLicensePlateError = (err: AxiosError<ErrorHttpResponse>) => {
    // toast.error(
    //   err?.response?.data?.message ??
    //   'Something went wrong while searching vehicle license plate.',
    // );
  };

  const onSearchVehicleLicensePlateSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    // toast.success('Vehicle license plate found successfully.');
    setFetchedVehicleLicenseData(data?.records || []);
  };

  const searchVehicleLicensePlate = (searchLicense: string, isAssigned: boolean = false) => {
    const urlString = `api/v1/fleets?isAssigned=${isAssigned}&page=0&size=50${searchLicense ? `&plateNumber=${searchLicense}` : ''}`;
    const url: HttpConfig = {
      url: urlString,
      method: 'get',
    };
    request(url, onSearchVehicleLicensePlateSuccess, setLoading, onSearchVehicleLicensePlateError);
  };

  return { searchVehicleLicensePlate, loading, fetchedVehicleLicenseData };
};

export default useVehicleLicensePlate;
